// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3MtfB","amount":"Amount_amount__2bGpd","tip":"Amount_tip__9Axwu","tipHeader":"Amount_tipHeader__2El8H","tipsWrap":"Amount_tipsWrap__3Z7un"};